<template>
  <div style="height:100%">
    <div class="fanhuibtn" v-show="back != ''" @click="toback">
      <img src="../../assets/img/icon/fanhui2.png" alt="">
      <span>返回</span>
    </div>
    <div style="height:88%;">
      <iframe id="iframeLive" ref="iframeLive" class="iframeLive" scrolling="no" frameborder="0" allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true"
        :src="LiveSrc"></iframe>
    </div>
    <div class="box" v-if="menulist.length > 0">
      <van-tabs :ellipsis="false" :sticky="true" offset-top="0" style="width:100%">
        <van-tab v-for="(item, index) in menulist" :key="index" :title="item.name">
          <div class="bbox">
            <div class="bbox">
              <div class="tuwenbox" v-if="item.type == 2">
                <div v-if="item.liveDetailList.length > 0" v-html="item.liveDetailList[0].contents"></div>
              </div>
              <div class="video display_flex" v-else-if="item.type == 3">
                <div v-for="(items, indexs) in item.liveDetailList" class="videoBox" :key="indexs + 's'"
                  @click="breadclk(items)">
                  <div class="video-card">
                    <img :src="items.coverPictureUrl" class="cont_img" alt="">
                    <img src="../../assets/img/icon/bofang3.png" class="btn" @click="toShipin(items)" alt="">
                    <div class="title ng-star-inserted">
                      <p>{{ items.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="link display_flex" v-else-if="item.type == 4">
                <div v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" class="linkBox"
                  @click="linkclk(items)">
                  <div class="display_center_lr" style="width:100%" v-if="items.coverPictureUrl != ''">
                    <img :src="items.coverPictureUrl" style="cursor: pointer" width="100%" height="300px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <van-popup v-model="isShipin" style="width:80%" @close="shipinClose">
        <div id="shipin"></div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer';
import { Dialog } from 'vant';
import { Toast } from 'vant';

export default {
  name: "huodeLive",
  data() {
    return {
      lId: '',
      LiveSrc: '',
      menulist: [],
      content: '',
      AuthorId: '',
      isShipin: false,
      shipinTitle: '',
      player: null,
      mtgId: 0,
      liveType: 2,
      LiveStreamType: 0,
      qid: 0,
      back: ''
    }
  },
  methods: {
    //获取授权地址
    GetUserAuth() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetHuodeViewUrl', {
        roomid: this.lId,
        userid: this.AuthorId
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          //预览地址 + 控制页面样式的参数
          _this.LiveSrc = data + '&nav=false&info=false&onlyVideo=true';
          //   +"&nav=false&info=false&onlyVideo=true"
        }
      });
    },
    //
    //获取菜单
    getLiveMenuById() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/getLiveMenuById', {
        Id: this.lId,
        LiveType: 2
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          if (data == null) data = []
          _this.menulist = data;
        }
      });
    },
    toback() {
      window.location.href = decodeURIComponent(this.back)
    },
    //超级链接跳转
    linkclk(item) {
      window.open(item.hyperlinks);
    },
    toShipin(item) {
      this.shipinTitle = item.title
      this.isShipin = true
      var test1 = setTimeout(() => {
        this.player = new Player({
          id: 'shipin',
          url: item.resUrl,
          autoplay: true,
          playsinline: true,
          width: '100%',
          height: 'auto'
        });
        clearTimeout(test1);
      }, 100);
    },
    shipinClose() {
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
      this.isShipin = false
    },
    regclick(cpg) {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              if (cpg > 0) {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                }
              } else {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                }
              }
            } else {
              if (!this.isDebug) {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              } else {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              }
            }
          });
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
        'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              if (cpg > 0) {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                }
              } else {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                }
              }
            } else {
              if (!this.isDebug) {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              } else {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              }
            }
          });
      } else {
        var hrefurl = '';
        if (cpg == 0) {
          if (!this.isDebug) {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          }
        } else {
          if (!this.isDebug) {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          }
        }
        let callback = encodeURIComponent(hrefurl);
        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;

      }
    },
    Defconfirm() {
      this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'userInfor' });
      });
    },
    toLive() {
      if (this.$route.query.LiveStreamType == 1) {
        this.LiveStreamType = 1
      }
      let _this = this
      _this.lId = this.$route.query.id
      if (_this.$route.query.mid != '' && _this.$route.query.mid != null && _this.$route.query.mid != '0') {
        _this.mtgId = _this.$route.query.mid;
        //验证是否需要报名
        _this.httphelper.post('/api/LiveApi/GetLiveRegistSet', {
          liveId: _this.lId,
          liveType: _this.liveType,
          mtgId: parseInt(_this.mtgId),
          userId: _this.AuthorId
        }).then(res => {
          if (res.data.code != 200) {
            //请先报名
            _this.regclick(0);
          } else {
            // if (_this.mtgId > 0) {
            _this.CheckIsQuestionnaire();
            // } else {
            //   _this.getMeetingInfo()
            //   //获取授权地址
            //   _this.GetUserAuth();
            //   //菜单绑定
            //   _this.getLiveMenuById();
            // }
          }
        });
      } else {
        _this.mtgId = 0;
        _this.CheckIsQuestionnaire();
      }
    },
    //验证是否需要问卷
    CheckIsQuestionnaire() {
      this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + this.lId + '&livetype=' + parseInt(this.liveType)).then(res => {
        if (res.code == 200) {
          this.getMeetingInfo()
          //获取授权地址
          this.GetUserAuth();
          //菜单绑定
          this.getLiveMenuById();
        } else {
          if (res.code == 20) {
            this.qid = res.data.id
            //验证当前用户是否报名
            this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedback?qid=' + res.data.id + '&userid=' + this.AuthorId).then(res => {
              if (res.code == 200) {
                this.getMeetingInfo()
                //获取授权地址
                this.GetUserAuth();
                //菜单绑定
                this.getLiveMenuById();
              } else {
                //跳转调查问卷 
                Dialog.alert({
                  title: '提示',
                  message: '请先填写调查问卷',
                })
                  .then(() => {
                    let callback = encodeURIComponent(window.location.href);
                    this.$router.push({
                      path: '/question?',
                      query: {
                        qid: this.qid,
                        callback: callback,
                        tokenkey: this.$route.query.tokenkey
                      },
                    })
                  })
              }
            });
          } else {
            Toast.fail(res.msg);
          }
        }
      });
    },
    getMeetingInfo() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetHuodeLiveById', {
        roomid: _this.lId
      }).then(res => {
        if (res.data.result == 'OK') {
          document.title = res.data.room.name || '全科医学网'
        }
      });
    },
  },
  created() {
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'back')) {
      this.back = this.$route.query.back
    }
    if (this.$cookies.isKey('token_chinagp')) {
      var _tokenkey = this.$cookies.get('token_chinagp');

      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$cookies.set('token_chinagp', _tokenkey);
            //访问直播页面
            this.AuthorId = res.data.data.id;
            this.toLive();
          } else {
            Dialog.alert({
              title: '提示',
              message: '请先登录',
            })
              .then(() => {
                let callback = encodeURIComponent(window.location.href);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              })
          }
        });
    } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'tokenkey')) {
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: this.$route.query.tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
            //访问直播页面
            this.AuthorId = res.data.data.id;
            this.toLive();
          } else {
            Dialog.alert({
              title: '提示',
              message: '请先登录',
            })
              .then(() => {
                let callback = encodeURIComponent(window.location.href);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              })
          }
        });
    } else {
      Dialog.alert({
        title: '提示',
        message: '请先登录',
      })
        .then(() => {
          let callback = encodeURIComponent(window.location.href);
          window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
        })
    }

  }
  // created () {

  //   let _this = this
  //   // 验证是否登录
  //   if (!localStorage.getItem('ResData')) {
  //     Dialog.alert({
  //       title: '提示',
  //       message: '请先登录',
  //     })
  //       .then(() => {
  //         let callback = encodeURIComponent(window.location.href);
  //         window.location.href = _this.httphelper.IsDebugH5GP519() +'/pages/login/login?callback=' + callback;
  //       })
  //   } else {
  //     this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
  //   }
  //   _this.lId = this.$route.query.id  //'F68ADA9EDD487ABC9C33DC5901307461'//
  //   if (_this.$route.query.mid != '' && _this.$route.query.mid != null && _this.$route.query.mid != '0') {
  //     _this.mtgId = _this.$route.query.mid;
  //     //验证是否需要报名
  //     _this.httphelper.post('/api/LiveApi/GetLiveRegistSet', {
  //       liveId: _this.lId,
  //       liveType: _this.liveType,
  //       mtgId: _this.mtgId,
  //       userId: _this.AuthorId
  //     }).then(res => {
  //       if (res.data.code != 200) {
  //         //请先报名
  //         _this.regclick(0);
  //       }
  //     });
  //   }
  //   //获取授权地址
  //   _this.GetUserAuth();
  //   //获取菜单,内容
  //   _this.getLiveMenuById();
  //   //绑定数据后,加上微信分享功能
  // }
}
</script>
 

<style scoped>
.ifbox {
  width: 100%;
  display: flex;
  justify-content: center;
  background-repeat: center;
  background-size: 1925px 1100px;
  background-image: url('../../assets/img/livebg.png');
  background-color: #eaf2fe;
  background-position: 50% 10px;
  overflow: hidden;
  position: relative;
}

.fanhuibtn {
  display: flex;
  align-items: center;
  /* height: 36px; */
  height: 5%;
  line-height: 36px;
  font-size: 14px;
}

.fanhuibtn img {
  width: 15px;
  height: 15px;
  margin-left: 10px;
  margin-right: 5px;
}

.iframeLive {
  /* min-width: 1500px !important;
    height: 585px; */
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}

.btitle {
  height: 60px;
  font-weight: 800;
  font-size: 18px;
}

.btitle img {
  margin-right: 20px;
}

.body {
  padding: 30px 0 70px;
}

.tuwenbox {
  padding: 10px 10px;
}
</style>

<style lang="scss" scoped>
.bbox {
  height: 36vh;
  overflow: auto;
}

.video {
  flex-wrap: wrap;
}

.videoBox {
  width: 46%;
  margin-left: 2.5%;
  margin-bottom: 10px;
}

.video-card {
  width: 100%;
  height: 140px;
  padding: 7px 10px;
  background-color: #f6f4fa;
  box-sizing: border-box;
  position: relative;
}

.video-card .cont_img {
  width: 100%;
  height: 80px;
  border-radius: 5px 5px 0 0;
}

.video-card .btn {
  position: absolute;
  top: 30px;
  left: 70px;
  cursor: pointer;
}

.video-card .title {
  height: 46px;
  border-radius: 0 0 5px 5px;
  background-color: #fff;
  margin-top: -3px;
  padding: 4px 5px 6px;
  box-sizing: border-box;
}

.video-card p {
  height: 36px;
  line-height: 18px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.link {
  flex-wrap: wrap;
  padding-top: 10px;
}

.linkBox {
  width: 46%;
  margin-left: 2.5%;
  margin-bottom: 10px;
}

#shipin ::v-deep .xgplayer-icon {
  margin-top: 0;
  bottom: 0;
  height: 32px;
}
</style>